import React, { Component } from 'react';
import { isEmpty } from '../Common/Common';
import Top_Bar from '../Part_Sample/Top_Bar';

import Guest_Room_Cell from './Component/Guest_Room_Cell';

export default class Guest_Room_Overview extends Component {
	constructor(props) {
		super(props);
		let guest_rooms = {};
		if (!isEmpty(this.props.param.guest_rooms)) {
			guest_rooms = JSON.parse(JSON.stringify(this.props.param.guest_rooms));
		}

		this.guest_room_settings = {
			locations: [],
			rooms: {}
		};

		if (!isEmpty(this.props.param.guest_room_settings)) {
			this.guest_room_settings = JSON.parse(JSON.stringify(this.props.param.guest_room_settings));
		}

		this.state = {
			guest_rooms: guest_rooms,
		}
	}

	updateRoomDetails = (cos_info) => {
		let room_list = Object.keys(cos_info);
		let guest_rooms = JSON.parse(JSON.stringify(this.state.guest_rooms));
		for (let room_name of room_list) {
			Object.assign(guest_rooms[room_name], cos_info[room_name]);
		}

		this.setState({ guest_rooms: guest_rooms })
	}

	render() {
		let style = {
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
			overflow: 'auto'
		}

		let is_show_locations = false;
		if (this.guest_room_settings.locations.length > 0) is_show_locations = true;

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('guest_rooms')}
					/>
					<div style={{ display: is_show_locations ? 'block' : 'none', width: this.props.width - 20, marginLeft: 'auto', marginRight: 'auto' }}>
						{this.guest_room_settings.locations.map((location_detail) => {
							return (
								<div style={{}}>
									<span className='header' style={{ fontSize: 18 }}>{location_detail.name}</span>
									{location_detail.room_order.map((room_name) => {
										let room_details = this.state.guest_rooms[room_name];
										if (!isEmpty(room_details)) {
											if (!isEmpty(this.guest_room_settings.rooms[room_name])) {
												room_details.icon = this.guest_room_settings.rooms[room_name].icon;
											} else {
												room_details.icon = '';
											}
											return (
												<Guest_Room_Cell
													room_details={room_details}
													receiver={this.props.receiver}
													colours={this.props.colours}
													is_disabled={false}
													width={this.props.width}
													height={this.props.height}
												/>
											)
										}
									})}
								</div>
							)
						})}
					</div>
					<div style={{ display: !is_show_locations ? 'block' : 'none', width: this.props.width - 20, marginLeft: 'auto', marginRight: 'auto' }}>
						{Object.keys(this.state.guest_rooms).map((room_name) => {
							let room_details = this.state.guest_rooms[room_name];
							if (!isEmpty(room_details)) {
								room_details.room_name = room_name;
								if (!isEmpty(this.guest_room_settings.rooms[room_name])) {
									room_details.icon = this.guest_room_settings.rooms[room_name].icon;
								} else {
									room_details.icon = '';
								}
								return (
									<Guest_Room_Cell
										room_details={room_details}
										receiver={this.props.receiver}
										colours={this.props.colours}
										is_disabled={false}
										width={this.props.width}
										height={this.props.height}
									/>
								)
							}
						})}
					</div>
				</div>
			</div>
		)
	}
}